export default {
  'DiscussedTopics.title': 'Популярное',
  'DiscussedTopics.positive': 'Позитив',
  'DiscussedTopics.negative': 'Негатив',
  'DiscussedTopics.topics': 'Темы',
  'DiscussedTopics.reviews': 'Отзывы',
  'DiscussedTopics.sentiment': 'Сентимент',
}
